import GraphQL from '@app/model/_common/service/GraphQL';
import { gql } from 'graphql-request';
import { SEARCH_HOTEL_WITHIN_RADIUS_RESULT_FRAGMENT } from '@app/model/flexi_sets/service/FlexiSetsGraphQLFragments';

export const FIND_HOTELS_AROUND_COMPANY_HOTEL_MAIN_HOTEL_QUERY: GraphQL = {
	name: 'findHotelsAroundCompanyHotelMainHotel',
	gql: gql`
      ${SEARCH_HOTEL_WITHIN_RADIUS_RESULT_FRAGMENT}
      query findHotelsAroundCompanyHotelMainHotel($filter: SearchHotelsFilter!) {
          findHotelsAroundCompanyHotelMainHotel(filter: $filter) {
              ...SearchHotelWithinRadiusResultFragment
          }
      }
	`
}

export const FIND_HOTELS_AROUND_COORDINATES_MUTATION:GraphQL = {
	name: 'findHotelsAroundCoordinates',
	gql: gql`
      ${SEARCH_HOTEL_WITHIN_RADIUS_RESULT_FRAGMENT}
      mutation findHotelsAroundCoordinates($filter: SearchHotelsFilter!) {
          findHotelsAroundCoordinates(filter: $filter) {
              ...SearchHotelWithinRadiusResultFragment
          }
      }
	`,
};

export const FIND_COMPETITORS_GROUP_HOTELS_QUERY: GraphQL = {
	name: 'findCompetitorsGroupHotels',
	gql: gql`
      ${SEARCH_HOTEL_WITHIN_RADIUS_RESULT_FRAGMENT}
      query findCompetitorsGroupHotels($companyHotelId: Long!, $competitorsGroupId: Long!) {
          findCompetitorsGroupHotels(companyHotelId: $companyHotelId, competitorsGroupId: $competitorsGroupId) {
              ...SearchHotelWithinRadiusResultFragment
          }
      }
	`,
};